import { NgModule, inject } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Role } from 'src/app/models/enums/Role';
import { StockMovementsComponent } from 'src/app/pages/operations/stock-movements/stock-movements.component';
import { AuthGuard } from 'src/app/services/auth/auth-guard';
import { AllocationComponent } from './allocation/allocation.component';
import { CepLookupComponent } from './cep-lookup/cep-lookup.component';
import { CompositionProductionsComponent } from './composition-productions/composition-productions.component';
import { CompositionDetailComponent } from './compositions/composition-detail/composition-detail.component';
import { CompositionsComponent } from './compositions/compositions.component';
import { EditionsDashboardComponent } from './editions-dashboard/editions-dashboard.component';
import { ResendComponent } from './resend/resend.component';
import { ResendDashboardComponent } from './resend-dashboard/resend-dashboard.component';
import { WaitingStockComponent } from './resend/waiting-stock/waiting-stock.component';

const routes: Routes = [
  {
    path: 'editions',
    component: EditionsDashboardComponent
  },
  {
    path: 'editions/:editionId',
    component: EditionsDashboardComponent
  },
  {
    path: 'compositions/id/:compositionId',
    component: CompositionDetailComponent
  },
  { path: 'compositions', component: CompositionsComponent },
  { path: 'compositions/:editionId', component: CompositionsComponent },
  { path: 'allocation', component: AllocationComponent },
  {
    path: 'composition-production',
    component: CompositionProductionsComponent
  },
  {
    path: 'composition-production/:editionId',
    component: CompositionProductionsComponent
  },
  {
    path: 'stock-movements',
    component: StockMovementsComponent
  },
  {
    path: 'resend-dashboard',
    component: ResendDashboardComponent
  },
  {
    path: 'resend-dashboard/:editionId',
    component: ResendDashboardComponent
  },
  {
    path: 'resend',
    component: ResendComponent
  },
  {
    path: 'resend/waiting-stock',
    component: WaitingStockComponent
  },
  {
    path: 'cep-lookup',
    component: CepLookupComponent,
    canActivate: [
      () =>
        inject(AuthGuard).canActivate() &&
        inject(AuthGuard).canActivatePermissions([
          Role.Full_Administrator,
          Role.Delivery,
          Role.Logistics,
          Role.User_Allocation,
          Role.Admin_Allocation
        ])
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OperationsRoutingModule {}
